<template>
  <div
    :class="['product-result results__card', { 'results__card--turn' : turn }]"
    @mouseover="turnBack(true)"
    @focusin="turnBack(true)"
    @focusout="turnBack(false)"
    @mouseout="turnBack(false)"
  >
    <slot name="face" />
    <slot name="back" />
  </div>
</template>

<script>
  export default {
    name: 'ProductResult',
    data() {
      return {
        turn: false
      };
    },
    methods: {
      turnBack(status) {
        this.turn = status;
      }
    }
  };
</script>
